import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserContractResponse } from '../models/UserContract';

@Injectable({
  providedIn: 'root'
})
export class UserContractService {
  private apiUrl = environment.API_URL;

  constructor(private http: HttpClient) { }

  getUserContracts(userId: number): Observable<UserContractResponse> {
    return this.http.get<UserContractResponse>(`${this.apiUrl}/template/user-contracts/${userId}`);
  }

  getContractPdf(contractId: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/template/contract/${contractId}`, {
      responseType: 'blob'
    });
  }
}